<template>
    <Popup>
        <!-- <template slot="ctrls">
            <i class="popup-ctrl-export" @click="onExport" title="导出" />
        </template> -->
        <div>
            <p v-for="(value, key) in fields" :key="key">
                <span style="margin-right: 5px;">{{ value.alias }}:</span>
                <span>{{ feature.properties[value.name] || "" }}</span>
            </p>
            <!-- <p v-for="(value, key) in feature.properties" :key="key">
                <b>{{ key }}：</b>
                <span>{{ feature.properties[key] }}</span>
            </p>
            <p v-if="emptyProperty">空属性</p> -->
        </div>
    </Popup>
</template>

<script>
import popup from '@/mixins/popup';
// import { exportShp } from '../scripts/analysisView';

export default {
    mixins: [popup],
    computed: {
        fields(){
            return this.$attrs.fields || []
        },
        emptyProperty() {
            if (
                this.feature &&
                this.feature.properties &&
                Object.keys(this.feature.properties).length
            ) {
                return false;
            }
            return true;
        },
    },
    methods: {
        onExport() {
            // exportShp([
            //     {
            //         key: 'shp',
            //         value: {
            //             type: 'FeatureCollection',
            //             features: [this.feature],
            //         },
            //     },
            // ]);
        },
    },
};
</script>
